import React from 'react';

function ReportSection({ title, subtitle, icon, children, className = '' }) {
  return (
    <section className={`bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700 p-5 break-inside-avoid ${className}`}>
      <div className="flex items-center justify-between gap-4 mb-4">
        <div>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-slate-500 dark:text-slate-400">
              {subtitle}
            </p>
          )}
        </div>
        {icon && <span className="material-symbols-outlined text-primary">{icon}</span>}
      </div>
      {children}
    </section>
  );
}

export default ReportSection;
